import { motion } from 'framer-motion'

interface OrbitalLoaderProps {
  size?: 'sm' | 'md' | 'lg'
}

export default function OrbitalLoader({ size = 'md' }: OrbitalLoaderProps) {
  const sizes = {
    sm: 40,
    md: 56,
    lg: 72,
  }

  const diameter = sizes[size]

  return (
    <div className="relative flex items-center justify-center">
      {/* Cercle fin qui tourne */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'linear',
        }}
        style={{
          width: diameter,
          height: diameter,
        }}
        className="rounded-full"
      >
        {/* Gradient arc (top half visible) */}
        <svg
          width={diameter}
          height={diameter}
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="28"
            cy="28"
            r="26"
            stroke="url(#gradient)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="80 100"
            style={{
              transformOrigin: 'center',
            }}
          />
          <defs>
            <linearGradient
              id="gradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor="#A855F7" stopOpacity="1" />
              <stop offset="50%" stopColor="#8B5CF6" stopOpacity="1" />
              <stop offset="100%" stopColor="#A855F7" stopOpacity="0.3" />
            </linearGradient>
          </defs>
        </svg>
      </motion.div>
    </div>
  )
}
